import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        const isMembershipPending = document.getElementById('is_membership_pending');
        const membership = document.getElementById('user_membership');

        if (isMembershipPending && isMembershipPending.checked) {
            membership.setAttribute('disabled', 'disabled');
            membership.removeAttribute('required');
        }

        isMembershipPending.addEventListener('click', function () {
            if (this.checked) {
                membership.setAttribute('disabled', 'disabled');
                membership.removeAttribute('required');
            } else {
                membership.removeAttribute('disabled');
                membership.setAttribute('required', 'required');
            }
        });
    }
}